import * as React from "react";
// import "./static/fonts/raleway/style.css";
import RootLayout from "./src/components/layouts/RootLayout";
// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  return <RootLayout {...props}>{element}</RootLayout>;
};
